import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Check, Upload } from "lucide-react";
import React, { useEffect, useState } from "react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import {
  getVendorsList,
  getPartAndAccessoriesList,
  getVehicleManufacturer,
  getVehicleManufacturerbyId,
  getCityName,
} from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";

const Others = ({ getVendorsListAPI }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const vendorTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vendorTypes;
  delete vendorTypes?.inverted;
  const [form, setForm] = useState({});
  const [vehicleManufacturerList, setVehicleManufacturerList] = useState([]);
  const [vehicleVendorList, setVehicleVendorList] = useState({});
  const [cities, setCities] = useState([]);

  const generatePartCode = () => {
    const makeName = vehicleManufacturerList[form?.vehiclemanufacturer] || "";
    const modelName = vehicleVendorList[form?.vendor] || "";

    const partCode =
      makeName.substring(0, 2) +
      modelName.substring(0, 2) +
      form?.vehiclemanufacturer +
      "-" +
      form?.vendor;

    setForm((prev) => ({
      ...prev,
      part: partCode,
    }));
  };

  useEffect(() => {
    if (form?.vehiclemanufacturer && form?.vendor) {
      generatePartCode();
    }
  }, [form?.vehiclemanufacturer, form?.vendor]);

  const addNewPartFields = [
    {
      label: "Vehicle Manufacturer",
      value: "vehiclemanufacturer",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vehicleManufacturerList).map(
        ([key, value]) => ({
          value: value,
          label: key,
        }),
      ),
    },
    {
      label: "Vendor",
      value: "vendor",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vehicleVendorList).map(([key, value]) => ({
        value: value,
        label: key,
      })),
    },
    {
      label: "Part",
      value: "part",
      type: "text",
      disabled: true,
    },
    {
      label: "Part Name",
      value: "partname",
      type: "text",
      disabled: false,
    },
  ];

  const addNewVendorFields = [
    {
      label: "Vendor / Company Name",
      value: "vendroorcompanyname",
      type: "text",
      disabled: false,
    },
    {
      label: "Vendor / Company Type",
      value: "vendororcompanytype",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vendorTypes).map(([key, value]) => ({
        value: value, // or whatever property you want
        label: key,
      })),
    },
    {
      label: "City",
      value: "city",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(cities).map(([key, value]) => ({
        value: value,
        label: key,
      })),
    },
    {
      label: "Address",
      value: "address",
      type: "text",
      disabled: false,
    },
    {
      label: "Contact Person",
      value: "contactperson",
      type: "text",
      disabled: false,
    },
    {
      label: "Contact Email",
      value: "contactemail",
      type: "text",
      disabled: false,
    },
    {
      label: "Contact Mobile",
      value: "contactmobile",
      type: "text",
      disabled: false,
    },
    {
      label: "GST No",
      value: "gstNo",
      type: "text",
      disabled: false,
    },
    {
      label: "PAN No",
      value: "panNo",
      type: "text",
      disabled: false,
    },
    {
      label: "Is Credit Allowed",
      value: "isCreditAllowed",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { value: "True", label: "1" },
        { value: "False", label: "0" },
      ],
    },
    {
      label: "Credit Amount",
      value: "creditAmount",
      type: "number",
      disabled: false,
    },
    {
      label: "Credit Days",
      value: "creditDays",
      type: "number",
      disabled: false,
    },
  ];

  const validateForm = (form) => {
    if (!form?.vendroorcompanyname) {
      toast.error("Enter Vendor company name", toastStyle);
      return false;
    }

    if (!form?.address) {
      toast.error("Enter vendor address", toastStyle);
      return false;
    }

    if (!form?.city) {
      toast.error("Select City", toastStyle);
      return false;
    }

    if (!form?.vendororcompanytype) {
      toast.error("Enter Vendor company type", toastStyle);
      return false;
    }

    if (!form?.contactperson) {
      toast.error("Enter Contact Person", toastStyle);
      return false;
    }

    if (!form?.contactemail) {
      toast.error("Enter Contact Email", toastStyle);
      return false;
    }

    if (!regex.email.test(form.contactemail)) {
      toast.error("Invalid email address", toastStyle);
      return false;
    }

    if (!form?.contactmobile) {
      toast.error("Enter Contact number", toastStyle);
      return false;
    }

    if (!regex.mobile.test(form.contactmobile)) {
      toast.error("Invalid mobile number", toastStyle);
      return false;
    }

    if (!form?.isCreditAllowed) {
      toast.error("Select Credit Allowance", toastStyle);
      return false;
    }

    const isCreditAllowedSelected =
      form?.isCreditAllowed === "True" ||
      form?.isCreditAllowed === true ||
      form?.isCreditAllowed === "1" ||
      form?.isCreditAllowed === 1;

    if (isCreditAllowedSelected) {
      if (!form?.creditAmount) {
        toast.error("Enter Credit Amount", toastStyle);
        return false;
      }

      if (!form?.creditDays) {
        toast.error("Enter Credit Days", toastStyle);
        return false;
      }
    }

    return true; // ✅ ONLY true reaches API
  };

  const regex = {
    text: /^[a-zA-Z\s]{2,50}$/,
    company: /^[a-zA-Z0-9\s&.,-]{2,100}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
    mobile: /^[6-9]\d{9}$/,
    address: /^[a-zA-Z0-9\s,./-]{5,200}$/,
  };

  const toastStyle = {
    position: "bottom-center",
    style: {
      background: "white",
      color: "red",
      fontWeight: "500",
      marginBottom: "50px",
    },
  };
  const handleChange = async (field, value) => {
    setForm((prev) => {
      if (field === "isCreditAllowed") {
        const allowed =
          value === "True" || value === true || value === "1" || value === 1;
        return {
          ...prev,
          [field]: value,
          creditAmount: allowed ? prev.creditAmount : "",
          creditDays: allowed ? prev.creditDays : "",
        };
      }
      return { ...prev, [field]: value };
    });
  };

  const isCreditAllowedSelected =
    form?.isCreditAllowed === "True" ||
    form?.isCreditAllowed === true ||
    form?.isCreditAllowed === "1" ||
    form?.isCreditAllowed === 1;

  const getCities = async (vehicleRegistration) => {
    const apiDetails = await getCityName(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setCities(data);
  };

  const getVehicleManufacturerAPI = async (vehicleRegistration) => {
    const apiDetails = await getVehicleManufacturer(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleManufacturerList(data);
  };

  const getVehicleManufacturerbyIdAPI = async (vehicleRegistration) => {
    const apiDetails = await getVehicleManufacturerbyId(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleVendorList(data);
  };

  useEffect(() => {
    getCities();
    getVehicleManufacturerAPI();
  }, []);

  useEffect(() => {
    if (form?.vehiclemanufacturer) {
      getVehicleManufacturerbyIdAPI(form?.vehiclemanufacturer);
    }
  }, [form?.vehiclemanufacturer]);

  const updateNewVendorDetailAPI = async () => {
    if (!validateForm(form)) return;
    try {
      const response = await fetch(`${apiUrl}/api/vendors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          name: form?.vendroorcompanyname,
          address: form?.address,
          cityId: form?.city,
          vendorType: form?.vendororcompanytype,
          contactPerson: form?.contactperson,
          contactEmail: form?.contactemail,
          contactMobile: form?.contactmobile,
          gstNo: form?.gstNo,
          panNo: form?.panNo,
          isCreditAllowed: form?.isCreditAllowed,
          creditAmount: form?.creditAmount || null,
          creditDays: form?.creditDays || null,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        toast.success("New Changes added successfully");
        getVendorsListAPI();
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const updateNewPartandAccessoriesDetails = async () => {
    if (!form?.vehiclemanufacturer) {
      toast.error("Select Vehcile Manufacturer", toastStyle);
      return;
    }

    if (!form?.partname) {
      toast.error("Enter Part Name", toastStyle);
      return;
    }

    if (!form?.part) {
      toast.error("Enter part", toastStyle);
      return;
    }

    if (!form?.vendor) {
      toast.error("Select Vendor type", toastStyle);
      return;
    }
    try {
      const response = await fetch(`${apiUrl}/api/partandaccessories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          name: form?.partname,
          partCode: form?.part,
          vehicleMake: form?.vehiclemanufacturer,
          vehicleMakeText: vehicleManufacturerList[form?.vehiclemanufacturer],
          vehicleModel: form?.vendor,
          vehicleModelText: vehicleVendorList[form?.vendor],
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        toast.success("New Part added successfully");
        getVendorsListAPI();
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="bg-[#34495e] text-white">
        <h1 className="px-6 py-4 text-left">Add New Part</h1>
      </div>
      <div className="flex-1 p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {addNewPartFields.map((field, index) => (
            <div key={index} className="group">
              <label className="block mb-2 font-semibold text-gray-700 text-sm">
                {field.label}
                {field.required && <span className="text-red-500 ml-1">*</span>}
              </label>

              {field.type === "dropdown" ? (
                <FormControl
                  fullWidth
                  size="small"
                  className="transition-all duration-200 hover:shadow-md"
                >
                  <InputLabel id={`drop-label-${index}`}>
                    {field?.label}
                  </InputLabel>
                  <Select
                    labelId={`drop-label-${index}`}
                    value={form[field.value] || ""}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    label={field?.label}
                    sx={{
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#e5e7eb",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#818cf8",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6366f1",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 240,
                          borderRadius: "8px",
                          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                        },
                      },
                    }}
                  >
                    {field?.subCategory
                      ?.filter((opt) => opt.item !== "inverted") // optional safety
                      .map((option, idx) => (
                        <MenuItem
                          key={idx}
                          value={option.key ?? option.label ?? option.value}
                        >
                          {option.value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              ) : field.type === "file" ? (
                <div className="space-y-3">
                  <div className="relative">
                    <input
                      disabled={field.disabled}
                      type="file"
                      id={`file-${index}`}
                      multiple
                      onChange={(e) =>
                        handleChange(field.value, e.target.files)
                      }
                      className="hidden"
                      accept="image/*"
                    />
                    <label
                      htmlFor={`file-${index}`}
                      className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                        field.disabled
                          ? "bg-gray-100 cursor-not-allowed"
                          : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                      }`}
                    >
                      <Upload size={20} className="text-indigo-600" />
                      <span className="text-sm text-gray-600">
                        {form[field.value] ? "Change file" : "Upload file"}
                      </span>
                    </label>
                  </div>
                  {form[field.value] && (
                    <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                      <img
                        src={
                          form[field.value].Location ||
                          form[field.value].path ||
                          form[field.value].url
                        }
                        className="w-full h-32 object-cover"
                        alt="Preview"
                      />
                      <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                        <Check size={16} />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <input
                  disabled={field.disabled}
                  type={field.type}
                  value={form[field.value] || ""}
                  onChange={(e) => handleChange(field.value, e.target.value)}
                  className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                    field.disabled
                      ? "bg-gray-100 cursor-not-allowed"
                      : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                  } outline-none`}
                  placeholder={`Enter ${field.label.toLowerCase()}`}
                />
              )}
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <Button
            sx={{
              bgcolor: "#0c4bc0ff",
              fontWeight: 500,
              px: 2,
              color: "white",
              borderRadius: 1,
              width: "200px",
              cursor: "pointer",
              "&:hover": {
                bgcolor: "#083a9a",
              },
            }}
            onClick={() => {
              updateNewPartandAccessoriesDetails();
            }}
          >
            Add Part
          </Button>
        </div>
      </div>

      <div className="bg-[#34495e] text-white">
        <h1 className="px-6 py-4 text-left">Add New Vendor</h1>
      </div>
      <div className="flex-1 p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {addNewVendorFields.map((field, index) => {
            const finalDisabled =
              field.disabled ||
              ((field.value === "creditAmount" || field.value === "creditDays") &&
                !isCreditAllowedSelected);

            return (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>

                {field.type === "dropdown" ? (
                  <FormControl
                    fullWidth
                    size="small"
                    disabled={finalDisabled}
                    className="transition-all duration-200 hover:shadow-md"
                  >
                    <InputLabel id={`drop-label-${index}`}>
                      {field?.label}
                    </InputLabel>
                    <Select
                      labelId={`drop-label-${index}`}
                      value={form[field.value] || ""}
                      onChange={(e) => handleChange(field.value, e.target.value)}
                      label={field?.label}
                      sx={{
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#818cf8",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted") // optional safety
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : field.type === "file" ? (
                  <div className="space-y-3">
                    <div className="relative">
                      <input
                        disabled={finalDisabled}
                        type="file"
                        id={`file-${index}`}
                        multiple
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                        className="hidden"
                        accept="image/*"
                      />
                      <label
                        htmlFor={`file-${index}`}
                        className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                          finalDisabled
                            ? "bg-gray-100 cursor-not-allowed"
                            : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                        }`}
                      >
                        <Upload size={20} className="text-indigo-600" />
                        <span className="text-sm text-gray-600">
                          {form[field.value] ? "Change file" : "Upload file"}
                        </span>
                      </label>
                    </div>
                    {form[field.value] && (
                      <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                        <img
                          src={
                            form[field.value].Location ||
                            form[field.value].path ||
                            form[field.value].url
                          }
                          className="w-full h-32 object-cover"
                          alt="Preview"
                        />
                        <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                          <Check size={16} />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <input
                    disabled={finalDisabled}
                    type={field.type}
                    value={form[field.value] || ""}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                      finalDisabled
                        ? "bg-gray-100 cursor-not-allowed"
                        : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                    } outline-none`}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                  />
                )}
              </div>
            );
          })}
        </div>

        <div className="flex justify-center mt-8">
          <Button
            sx={{
              bgcolor: "#0c4bc0ff",
              fontWeight: 500,
              px: 2,
              color: "white",
              borderRadius: 1,
              width: "200px",
              cursor: "pointer",
              "&:hover": {
                bgcolor: "#083a9a",
              },
            }}
            onClick={() => {
              updateNewVendorDetailAPI();
            }}
          >
            Add Vendor
          </Button>
        </div>
      </div>
    </>
  );
};

export default Others;
